import React from 'react';

const ProjectsDrawerIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1806_1442)">
        <path d="M18.455 16.7884L16.7884 18.455L12.5 14.1667V12.5H14.1667L18.455 16.7884ZM19.8784
          18.2117L19.045 17.3784L17.3784 19.045L18.2117 19.8784C18.3742 20.0409 18.6384 20.0409
          18.8009 19.8784L19.8784 18.8009C20.0409 18.6375 20.0409 18.3742 19.8784
          18.2117ZM5.83337 9.16671H7.50004V10.8334H5.83337V9.16671ZM9.16671
          9.16671H14.1667V10.8334H9.16671V9.16671ZM3.33337
          5.83337H16.6667V7.50004H3.33337V5.83337ZM5.8333712.5H7.50004V14.1667H5.83337V12.5ZM9.16671
          12.5H10.8334V14.1667H9.16671V12.5Z" fill="#757575"/>
        <path d="M11.8092 15.8333H4.16667V4.16667H15.8333L15.8325 11.8092L17.5 13.4767V4.16667C17.5
          3.24583 16.7542 2.5 15.8333 2.5H4.16667C3.24583 2.5 2.5 3.24583 2.5 4.16667V15.8333C2.5
          16.7542 3.24583 17.5 4.16667 17.5H13.4758L11.8092 15.8333Z" fill="#757575"/>
        <path opacity="0.3" d="M3.33337 3.33337H16.6667V6.66671H3.33337V3.33337Z" fill="#757575"/>
      </g>
      <defs>
        <clipPath id="clip0_1806_1442">
          <rect width="20" height="20" fill="#757575"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default ProjectsDrawerIcon;
